<template lang="pug">
	div.container-fluid
		.card
			.card-header.bg-info.text-white
				span.fa.fa-search.mr-2
				| Auditor de emisiones
			.card-body
				.row
					.col-xs-12.col-sm-12.col-md-4.col-lg-2.col-xl-2
						.form-group
							label Fecha de inicio
							datepicker(
								v-model="filtro.FechaInicio"
								:bootstrap-styling="true"
								input-class="form-control"
								:monday-first="true"
								:language="$dateLang"
							)
						.form-group
							label Fecha de fin
							datepicker(
								v-model="filtro.FechaFin"
								:bootstrap-styling="true"
								input-class="form-control"
								:monday-first="true"
								:language="$dateLang"
							)

					.col-xs-12.col-sm-12.col-md-4.col-lg-2.col-xl-2
						.form-group
							label Agente
							input-query(
								v-if="permisos.auditor_verTodos && !filtro.AgenteID",
								@selected="setAgente($event)"
								input-class="form-control"
								url="auditor/php/api/query-agentes.php"
								:realtime="true"
								)
							.input-group(v-else-if="filtro.AgenteID")
								input.form-control(disabled, :value="agenteNombre")
								.input-group-append
									button.btn.btn-danger(@click="quitarAgente")
										span.fa.fa-trash
							input.form-control(v-else, disabled, :value="usuario.nombre + ' ' + usuario.apellidos")
						.form-group
							label Soporte(s)
							input-query.form-control(
								@selected="setSoporte($event)"
								input-class="form-control"
								url="/auditor/php/api/query-soportes.php"
								:realtime="true"
							)
						div
							button.btn.btn-sm.btn-danger.m-2(v-for="sop in filtro.Soportes", :key="sop.ID_soporte", @click="quitarSoporte(sop)")
								span.fa.fa-trash.mr-2
								| {{sop.soporte}}

					.col-xs-12.col-sm-12.col-md-4.col-lg-2.col-xl-2
						.form-group
							label Cliente
							input.form-control(v-model="filtro.ClienteNombre")
						.form-group
							label Anunciante
							input.form-control(v-model="filtro.AnuncianteNombre")

					.col-xs-12.col-sm-12.col-md-4.col-lg-2.col-xl-2
						.form-group
							label Contrato
							input-query(
								v-if="!filtro.ContratoID"
								@selected="setContrato($event)"
								url="/auditor/php/api/query-contratos.php"
								input-class="form-control"
								:realtime="true"
							)
							.input-group(v-else)
								input.form-control(disabled, :value="contratoTitulo")
								.input-group-append
									button.btn.btn-danger(@click="quitarContrato")
										span.fa.fa-trash
						.form-group
							label Facturado a
							select.form-control(v-model="filtro.DestinoID")
								option(:value="null") Todos
								option(v-for="destino in listadoDestinos", :value="destino.ID_destino", :key="destino.ID_destino") {{destino.texto}}

					.col-xs-12.col-sm-12.col-md-4.col-lg-2.col-xl-2
						.form-group
							label Intermediario
							input-query(
								v-if="!filtro.IntermediarioID"
								@selected="setIntermediario($event)"
								url="/auditor/php/api/query-intermediarios.php"
								input-class="form-control"
								:realtime="true"
							)
							.input-group(v-else)
								input.form-control(disabled, :value="intermediarioNombre")
								.input-group-append
									button.btn.btn-danger(@click="quitarIntermediario")
										span.fa.fa-trash
						.form-group
							label Agrupado
							select.form-control(v-model="filtro.CampoAgrupado")
								option(:value="null") Sin agrupar
								option(v-for="campo in listadoCampos", :key="campo.campo", :value="campo.campo") {{campo.descripcion}}

					.col-xs-12.col-sm-12.col-md-4.col-lg-2.col-xl-2
						.form-group
							label Descripcion fichero / Matrícula
							input.form-control(v-model="filtro.Descripcion")
			.card-footer
				button.btn.btn-primary(@click="buscar")
					span.fa.fa-search.mr-2
					| Buscar
				button.btn.btn-success.ml-2(
					@click="descargarFicheros()"
					:disabled="filtro.CampoAgrupado !== 'FicheroMatricula' || !filtro.FechaInicio || !filtro.FechaFin"
				)
					span.fa.fa-download.mr-2
					span Descargar cuñas
				download-excel(
						v-if="resultados.length > 0"
						class   = "btn btn-warning ml-2"
						:data   = "json_data"
						:fields = "json_fields"
						:meta   = "json_meta"
						name	= "filename.xls")

					span.fa.fa-download.mr-2
					| XLS

		.card
			.card-header.bg-dark.text-white
				.row
					.col.text-left
						span.fa.fa-list.mr-2
						| Resultados
					.col.text-right(v-if="paginas > 1")
						div(style="position:relative;display:inline-block;")
							ul.pagination.justify-content-end.pagination-sm
								li.page-item(
									v-for="p in botonesPagina"
									:class="(pagina === p.pagina) ? 'active' : ''"
								)
									span.page-link(
										v-if="p.activa"
										@click="verPagina(p.pagina)"
									) {{p.pagina + 1}}
									span.page-link.disabled(
										v-else
									) {{p.pagina}}
						input.form-control.form-control-sm.ml-2(style="position:relative;display:inline-block;width:50px;", v-model.number="saltarPagina", @keypress.enter="verPagina(saltarPagina - 1)", placeholder="Pág")

			table.table.table-striped
				thead
					tr
						th(v-if="columnasOcultas.indexOf('AnuncianteNombre') < 0") Anunciante
						th(v-if="columnasOcultas.indexOf('ClienteNombre') < 0") Cliente
						th(v-if="columnasOcultas.indexOf('SoporteNombre') < 0") Soporte
						th(v-if="columnasOcultas.indexOf('FechaEmision') < 0") Fecha emisión
						th(v-if="columnasOcultas.indexOf('ContratoTitulo') < 0") Contrato
						th(v-if="columnasOcultas.indexOf('ProduccionTitulo') < 0") Campaña
						th(v-if="columnasOcultas.indexOf('FicheroNombre') < 0") Fichero
						th(v-if="columnasOcultas.indexOf('FicheroMatricula') < 0") Matrícula
						th(v-if="columnasOcultas.indexOf('AgenteNombre') < 0") Agente
						th(v-if="resultadosAgrupados") Total emisiones
				tbody
					tr(v-for="emision in paginaActual", :key="emision.EmisionID")
						td(v-if="columnasOcultas.indexOf('AnuncianteNombre') < 0") {{emision.AnuncianteNombre}}
						td(v-if="columnasOcultas.indexOf('ClienteNombre') < 0") {{emision.ClienteNombre}}
						td(v-if="columnasOcultas.indexOf('SoporteNombre') < 0") {{emision.SoporteNombre}}
						td(v-if="columnasOcultas.indexOf('FechaEmision') < 0") {{emision.FechaEmision}}
						td(v-if="columnasOcultas.indexOf('ContratoTitulo') < 0") {{emision.ContratoTitulo}}
						td(v-if="columnasOcultas.indexOf('ProduccionTitulo') < 0")
							div {{emision.ProduccionTitulo}}
							div(style="opacity:0.7;") {{emision.TareaTitulo}}
						td(v-if="columnasOcultas.indexOf('FicheroNombre') < 0") {{emision.FicheroNombre}}
						td(v-if="columnasOcultas.indexOf('FicheroMatricula') < 0") {{emision.FicheroMatricula}}
						td(v-if="columnasOcultas.indexOf('AgenteNombre') < 0") {{emision.AgenteNombre}}
						td(v-if="resultadosAgrupados") {{emision.EmisionesTotales}} emisiones
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
export default {
	data () {
		return {
			filtro: {
				FechaInicio: null,
				FechaFin: null,
				AgenteID: null,
				AnuncianteNombre: null,
				ClienteNombre: null,
				ContratoID: null,
				Descripcion: null,
				DestinoID: null,
				IntermediarioID: null,
				Soportes: [],
				CampoAgrupado: null
			},
			agenteNombre: null,
			contratoTitulo: null,
			intermediarioNombre: null,
			listadoDestinos: [],
			listadoCampos: [
				{
					campo: 'ClienteID',
					descripcion: 'Cliente'
				},
				{
					campo: 'AnuncianteID',
					descripcion: 'Anunciante'
				},
				{
					campo: 'AgenteID',
					descripcion: 'Agente'
				},
				{
					campo: 'SoporteID',
					descripcion: 'Soporte'
				},
				{
					campo: 'FicheroMatricula',
					descripcion: 'Matrícula'
				},
				{
					campo: 'ContratoID',
					descripcion: 'Contrato'
				}
			],
			resultados: [],
			resultadosAgrupados: false,
			pagina: 0,
			resultadosPorPagina: 100,
			saltarPagina: null
		}
	},
	created () {
		this.getlistadoDestinos()
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		}),
		columnasOcultas () {
			let cols = []
			if (!this.resultadosAgrupados) {
				return []
			}

			switch (this.resultadosAgrupados) {
			case 'ClienteID':
				cols = [
					'AnuncianteNombre',
					'SoporteNombre',
					'FechaEmision',
					'ContratoTitulo',
					'ProduccionTitulo',
					'FicheroNombre',
					'FicheroMatricula',
					'AgenteNombre'
				]
				break
			case 'AnuncianteID':
				cols = [
					'ClienteNombre',
					'SoporteNombre',
					'FechaEmision',
					'ContratoTitulo',
					'ProduccionTitulo',
					'FicheroNombre',
					'FicheroMatricula',
					'AgenteNombre'
				]
				break
			case 'AgenteID':
				cols = [
					'ClienteNombre',
					'AnuncianteNombre',
					'SoporteNombre',
					'FechaEmision',
					'ContratoTitulo',
					'ProduccionTitulo',
					'FicheroNombre',
					'FicheroMatricula'
				]
				break
			case 'SoporteID':
				cols = [
					'ClienteNombre',
					'AnuncianteNombre',
					'FechaEmision',
					'ContratoTitulo',
					'ProduccionTitulo',
					'FicheroNombre',
					'FicheroMatricula',
					'AgenteNombre'
				]
				break
			case 'FicheroMatricula':
				cols = [
					'FechaEmision',
					'SoporteNombre'
				]
				break
			case 'ContratoID':
				cols = [
					'AnuncianteNombre',
					'SoporteNombre',
					'FechaEmision',
					'ProduccionTitulo',
					'FicheroNombre',
					'FicheroMatricula'
				]
				break
			default:
				cols = []
				break
			}

			return cols
		},
		paginaActual () {
			if (this.resultados.length <= this.resultadosPorPagina) {
				return this.resultados
			}

			return this.resultados.filter((val, i) => {
				return (i >= (this.pagina * this.resultadosPorPagina) && i <= (this.pagina + 1) * this.resultadosPorPagina)
			})
		},
		paginas () {
			return Math.ceil(this.resultados.length / this.resultadosPorPagina)
		},
		botonesPagina () {
			const paginas = []
			if (this.paginas < 10) {
				for (let i = 0; i < this.paginas; i++) {
					paginas.push({
						pagina: i,
						activa: true
					})
				}
				return paginas
			}

			const inicio = (this.pagina <= 5) ? 0 : this.pagina - 5
			for (let i = inicio; i < inicio + 7; i++) {
				paginas.push({
					pagina: i,
					activa: true
				})
			}

			paginas.push({
				pagina: '...',
				activa: false
			})

			for (let i = this.paginas - 6; i < this.paginas; i++) {
				paginas.push({
					pagina: i,
					activa: true
				})
			}

			return paginas
		},
		json_data () {
			return this.resultados
		},
		json_fields () {
			const arr = {
				AnuncianteNombre: 'AnuncianteNombre',
				ClienteNombre: 'ClienteNombre',
				SoporteNombre: 'SoporteNombre',
				FechaEmision: 'FechaEmision',
				ContratoTitulo: 'ContratoTitulo',
				ProduccionTitulo: 'ProduccionTitulo',
				FicheroNombre: 'FicheroNombre',
				FicheroMatricula: 'FicheroMatricula',
				AgenteNombre: 'AgenteNombre'
			}

			if (this.resultadosAgrupados) {
				arr.EmisionesTotales = 'EmisionesTotales'
			}
			return arr
		},
		json_meta () {
			return [
				[{
					'key': 'charset',
					'value': 'utf-8'
				}]
			]
		}
	},
	methods: {
		verPagina (p) {
			this.pagina = p
		},
		paginaSiguiente () {
			if (this.pagina + 1 < this.paginas) {
				this.pagina++
			} else {
				this.pagina = 0
			}
		},
		paginaAnterior () {
			if (this.pagina === 0) {
				this.pagina = this.paginas - 1
			} else {
				this.pagina--
			}
		},
		getlistadoDestinos () {
			axios.get('/auditor/php/api/listado-destinos.php')
				.then(res => {
					this.listadoDestinos = res.data.resultados
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: 'Error obteniendo el listado de destinos'
					})
				})
		},
		setAgente (e) {
			this.filtro.AgenteID = e.data.ID
			this.agenteNombre = e.data.Nombre
		},
		quitarAgente () {
			this.filtro.AgenteID = null
			this.agenteNombre = null
		},
		setContrato (e) {
			this.filtro.ContratoID = e.data.ID_contrato
		},
		quitarContrato () {
			this.filtro.ContratoID = null
			this.contratoTitulo = null
		},
		setSoporte (e) {
			if (this.filtro.Soportes.filter(a => a.ID_soporte === e.data.ID_soporte).length === 0) {
				this.filtro.Soportes.push(e.data)
			}
		},
		quitarSoporte (sop) {
			this.filtro.Soportes = this.filtro.Soportes.filter(a => a !== sop)
		},
		setIntermediario (e) {
			this.filtro.IntermediarioID = e.data.ID_intermediario
			this.intermediarioNombre = e.data.nombre
		},
		quitarIntermediario () {
			this.filtro.IntermediarioID = null
			this.intermediarioNombre = null
		},
		descargarFicheros () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Descargar audios',
				mensaje: 'Este proceso puede demorarse, por lo que tendrás que tener paciencia. ¿Quieres continuar?',
				callback: (accept) => {
					if (accept) {
						const form = JSON.parse(JSON.stringify(this.filtro))
						form.FechaInicio = (this.filtro.FechaInicio) ? Math.round(this.filtro.FechaInicio.getTime() / 1000) : null
						form.FechaFin = (this.filtro.FechaFin) ? Math.round(this.filtro.FechaFin.getTime() / 1000) : null
						this.resultadosAgrupados = null
						this.download('/auditor/php/api/descargar.php', form, 'audios.zip', () => {
							console.log('Terminado')
						})
					}
				}
			})
		},
		buscar () {
			const form = JSON.parse(JSON.stringify(this.filtro))
			form.FechaInicio = (this.filtro.FechaInicio) ? Math.round(this.filtro.FechaInicio.getTime() / 1000) : null
			form.FechaFin = (this.filtro.FechaFin) ? Math.round(this.filtro.FechaFin.getTime() / 1000) : null
			this.resultadosAgrupados = null
			axios.post('/auditor/php/api/consultar.php', form)
				.then(res => {
					this.pagina = 0
					this.resultados = res.data.resultados
					this.resultadosAgrupados = res.data.agrupado
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: 'Error en la búsqueda'
					})
				})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/auditor/vue/componentes/buscador/buscador.vue